import React, { useRef, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { analyticsService } from '@common/analytics';
import { Popover } from '@barges/react';
import classes from './classes.module.scss';
import { usePromoCode } from '../../hooks/usePromoCode';

const onCodeSent = (code, applyCode, onOkClickSignUpPromoReadAction) => {
  if (code && code.length !== 0) {
    applyCode(code);
  } else {
    onOkClickSignUpPromoReadAction();
  }
};

const onShowModal = (modalText) => {
  if (modalText) return true;
  return false;
};

const renderModalButtons = (success, onOkClickSignUpPromoReadAction, clearShowModal, t) => {
  if (!success) {
    return (
      <div className={ classes.promoCodeModalButtonContainer }>
        <button type="button" value="Promo Code" className={ classes.promoCodeModalButton } onClick={ onOkClickSignUpPromoReadAction }>
          <b>{ t('promoCode.continue_without_promo') }</b>
        </button>
        <button type="button" value="Promo Code" className={ classes.promoCodeModalButton } onClick={ clearShowModal }>
          <b>{ t('promoCode.reenter_promo') }</b>
        </button>
      </div>
    );
  }
  return (
    <div className={ classes.promoCodeModalButtonContainer }>
      <button type="button" value="Promo Code" className={ classes.promoCodeModalButton } onClick={ clearShowModal }>
        <b>{ t('promoCode.ok') }</b>
      </button>
    </div>
  );
};

function PromoCodeSignUp({
  onOkClickSignUpPromoRead, promo = ''
}) {
  const { t } = useTranslation();
  const codeInput = useRef();
  const {
    loading, success, modalText, applyCode, clearModalText
  } = usePromoCode();

  useEffect(() => {
    analyticsService.trackPageVisit('promo code sign up complete', true);
  }, []);

  const clearShowModal = () => {
    if (success) onOkClickSignUpPromoRead();
    clearModalText();
  };

  const onOkClickSignUpPromoReadAction = () => {
    onOkClickSignUpPromoRead();
    clearModalText();
  };

  const codeSent = () => {
    const code = codeInput.current.value;
    onCodeSent(code, applyCode, onOkClickSignUpPromoReadAction);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      codeSent();
    }
  };

  const showModal = () => onShowModal(modalText);

  const renderModalContent = () => (
    <div className={ classes.promoCodeModalContainer }>
      <div className={ classes.promoCodeModalHeader }>
        <b>{ t('app_name_title') }</b>
      </div>
      <div className={ classes.promoCodeModalBody }>
        { modalText }
      </div>
      <div className={ classes.modalFooter }>
        { renderModalButtons(success, onOkClickSignUpPromoReadAction, clearShowModal, t) }
      </div>
    </div>
  );

  return (
    <div>
      <Trans
        i18nKey="promoCode.sign_up_complete"
        components={ {
          normal:<div className={ classes.text } />,
          bold:<b />
        } }
      />
      <div>
        <input
          placeholder = { t('promoCode.enter_code_optional') }
          ref={ codeInput }
          className = { classes.inputContent }
          onKeyDown={ handleKeyPress }
          defaultValue={ promo }
        />
      </div>
      <div>
        <button type="button" value="Promo Code" disabled={ loading } onClick={ codeSent } className={ classes.submitButton }>
          { t('promoCode.continue') }
        </button>
      </div>
      <Popover isOpen={ showModal() } centered className="promo-code-sign-up-modal">
        { renderModalContent()}
      </Popover>
    </div>
  );
}

export default PromoCodeSignUp;
